export class SelectedRes {
  selected = [];
  pointOfLift = '3';
  videoTime = '5';
  startDate = new Date();
  endDate = new Date();
}
